import React from "react"
import { VideoPlayer, Text, Flex } from "@capioweb/ui-components"
import { QBankImage } from "../../@types/CapioWeb/core"
import {
	StringProperty,
	BooleanProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { imagePath } from "../../utils/imageDataToImageProps"
import { LocalesContext } from "../../context/LocalesContext"
import {
	INNER_MAX_WIDTH,
	READABLE_LINE_MAX_WIDTH,
} from "@capioweb/ui-components/src"
import { assetBaseUrl, createMarkup,base64Decode } from "../../utils"

interface CapioImageVideoBlockProps {
	image: QBankImage
	imageCaption: StringProperty
	youTubeLink: StringProperty
	youTubeFullScreen: BooleanProperty
	youTubeAutoPlay: BooleanProperty
	leftAligned: BooleanProperty
	verticalFormat?: BooleanProperty
	playButtonCaption: StringProperty
	videoEmbed: string
}

// Used on start page and unit listing
const CapioImageVideoBlock: React.FC<CapioImageVideoBlockProps> = (props) => {
	const { translate, translationKeys } = React.useContext(LocalesContext)

	const CaptionBlock = (
		<Flex w={1} backgroundColor="greyF3" p={{ _: 2, m: 3 }}>
			<Text fontStyle="italic" fontSize={1.75} lineHeight={2.5} mb={0}>
				{props.imageCaption?.value}
			</Text>
		</Flex>
	)

	return (
		<Flex as="section" w={1} px={3} pb={3}>
			<Flex
				w={1}
				flexDirection="column"
				maxw={INNER_MAX_WIDTH}
				style={{ margin: "0 auto" }}
			>
				<Flex
					maxw={
						props.leftAligned.value ? READABLE_LINE_MAX_WIDTH : INNER_MAX_WIDTH
					}
					flexDirection="column"
				>
					{props.youTubeLink.value || props.videoEmbed ? (
					 props.videoEmbed ? <Flex w={1} flexDirection="column" dangerouslySetInnerHTML={createMarkup(base64Decode(props.videoEmbed))}></Flex> :
					 <VideoPlayer
							locales={{
								playBtnLabel: translate(translationKeys.playVideo),
							}}
							posterUrl={
								props.image?.media?.value &&
								imagePath(`${props.image.media.value.url}?format=webp`)
							}
							autoPlay={props.youTubeAutoPlay.value}
							url={props.youTubeLink.value ?? ""}
							allowFullScreen={false}
							playsinline={props.youTubeFullScreen.value ?? false}
							controls={props.youTubeFullScreen.value ?? true}
							verticalFormat={props.verticalFormat.value}
							playButtonCaption={props.playButtonCaption.value}
						>
							{props.imageCaption?.value && CaptionBlock}
						</VideoPlayer>
					) : (
						<>
							<Flex w={1}>
								<img
									src={`${assetBaseUrl()}${
										props.image?.media?.value?.url
									}?format=webp`}
									alt={props.image?.alternateText?.value}
									title={props.image?.imageTitle?.value}
									width="100%"
									height="100%"
									style={{ objectFit: "cover", aspectRatio: "3/2" }}
								/>
							</Flex>
							{props.imageCaption?.value && CaptionBlock}
						</>
					)}
				</Flex>
			</Flex>
		</Flex>
	)
}

export { CapioImageVideoBlock }
